import { User } from 'models';
import { UserAnalyticsMicroMessageContent } from 'models/analytics';

function getUserAnalyticsMicroMessage(user: User) {
  const messageContent: UserAnalyticsMicroMessageContent = {
    hubUserId: `${user?.seqId ?? 'ANONYMOUS'}`,
    userSegment: `${user?.industry ?? 'PREVIEW'}`,
    hubUserStatus: `${user?.isTestUser ? 'testuser' : 'realuser'}`,
  };

  return {
    schemaName: 'affiliateHubUser',
    messageContent,
  };
}

export { getUserAnalyticsMicroMessage };
